import React from 'react';
import { Input } from '@/components/ui/input';
import { EmailBodyEditor } from './EmailBodyEditor';
import { EmailPreview } from './EmailPreview';

interface MessageStepProps {
  reportTitle: string;
  subject: string;
  subjectError: string;
  onSubjectChange: (_value: string) => void;
  body: string;
  bodyError: string;
  onBodyChange: (_value: string) => void;
}

export const MessageStep: React.FC<MessageStepProps> = ({
  reportTitle,
  subject,
  subjectError,
  onSubjectChange,
  body,
  bodyError,
  onBodyChange,
}) => (
  <div className="flex w-full flex-col items-start gap-4 rounded-lg border border-[#E5E5E5] bg-white p-4 sm:flex-row sm:gap-6">
    <div className="flex w-full min-w-0 flex-col gap-4 sm:max-w-[619px] sm:flex-none">
      <div className="flex w-full flex-col gap-2">
        <label className="font-sans text-sm font-medium leading-none text-[#0A0A0A]">
          Assunto <span className="text-red-500">*</span>
        </label>
        <Input
          value={subject}
          onChange={(event) => onSubjectChange(event.target.value)}
          placeholder="Insira o assunto do e-mail"
          className={
            subjectError
              ? 'h-9 rounded-lg border-red-500 px-3 py-1 shadow-none focus-visible:ring-red-500'
              : 'h-9 rounded-lg border-[#E5E5E5] px-3 py-1 shadow-none'
          }
        />
        {subjectError ? (
          <p className="text-sm text-red-500">{subjectError}</p>
        ) : null}
      </div>

      <div className="flex min-h-0 w-full flex-1 flex-col gap-2">
        <label className="font-sans text-sm font-medium leading-none text-[#0A0A0A]">
          Corpo do E-mail <span className="text-red-500">*</span>
        </label>
        <EmailBodyEditor
          value={body}
          onChange={onBodyChange}
          error={bodyError}
          placeholder="Insira o texto do corpo do e-mail"
        />
        {bodyError ? (
          <p className="text-sm text-red-500">{bodyError}</p>
        ) : null}
      </div>
    </div>

    <EmailPreview reportTitle={reportTitle} subject={subject} body={body} />
  </div>
);
